<template>
  <ItemPage
    title="Volume"
    size="md"
    :actions="actions"
  >
    <v-form
      ref="form"
    >
      <v-container>
        <v-row>
          <v-col
            cols="6"
            class="mr-auto"
          >
            <v-text-field
              v-model="volume.name"
              :rules="rulesName"
              :disabled="volumeUpdate"
              label="Nome"
              @input="checkUpdate"
            />
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="volume.slug"
              :disabled="volumeUpdate"
              :rules="[() => (sizes(volume.name) < 20 || sizes(volume.slug) > 1) || 'Nome maior que 20 caracteres, inclua sigla(min. 2 caracteres)', () => (volume.slug === null || volume.slug === '' || sizes(volume.slug) <21 && sizes(volume.slug) > 1 ) || 'inclua sigla(min. 2, max 20 caracteres)']"
              :error-messages="formError.slug"
              :counter="20"
              maxlength="20"
              label="Abreviatura"
              @input="checkUpdate"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </ItemPage>
</template>

<script>
import utils from '@/api/utils.js'
import ItemPage from '@/components/pages/ItemPage.vue'

export default {
  components: {
    ItemPage
  },
  data () {
    return {
      dialogConfirm: false,
      btnDisable: true,
      renderComponent: 0,
      rulesName: [
        value => !!value || 'Preenchimento obrigatório.',
        value => (value && value.length >= 3) || 'Min 3 caracteres'
      ],
      dialogAddGradeLevel: false,
      loading: false,
      loadingSave: false,
      update: false,
      request: false,
      snackbar: false,
      msgSnackbar: '',
      timeout: 3000,
      currentVolume: {},
      volume: {},
      formError: {}
    }
  },
  computed: {
    id () {
      return this.$route.params.id
    },
    volumeUpdate () {
      return !utils.checkPermissions('volumes.update-any')
    },
    volumeDelete () {
      return !utils.checkPermissions('volumes.delete')
    },

    actions () {
      return [
        {
          label: 'Atualizar',
          action: this.updateVolumes,
          icon: 'mdi-floppy',
          disabled: this.btnDisable
        },
        {
          label: 'Deletar',
          action: this.deleteVolume,
          icon: 'mdi-delete',
          disabled: this.volumeDelete
        }
      ]
    }
  },
  created () {
    this.fetchAll()
  },
  methods: {
    async fetchAll () {
      await this.getVolumes()
    },
    async getVolumes () {
      this.loading = true
      this.loadingMsg = 'Carregando lista de volumes...'
      try {
        const response = await this.$api.getVolume(this.id)
        this.volume = response
        this.currentVolume = utils.currentData(response)
      } catch {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível obter volume, tente novamente mais tarde.', color: 'red' })
      }
      this.loading = false
    },
    validate () {
      return this.$refs.form.validate()
    },
    sizes (data) {
      return utils.size(data)
    },
    checkUpdate () {
      const data = utils.newData(this.volume, this.currentVolume)
      if (utils.size(data) > 0) {
        this.btnDisable = false
      } else {
        this.btnDisable = true
      }
      return data
    },
    async deleteVolume () {
      this.$dialog.confirm('Apagar volume?')
        .text('Essa ação não pode ser desfeita')
        .label('Apagar')
        .onConfirm(async () => {
          this.request = true
          try {
            await this.$api.deleteVolumes(this.id)
            this.request = false
            this.$store.dispatch('setSnackBar', { text: 'volume excluido com sucesso.' })
            this.$router.back()
          } catch {
            this.request = false
            this.$store.dispatch('setSnackBar', { text: 'Não foi possível Excluir, tente novamente mais tarde.', color: 'red' })
          }
        })
        .show()
    },
    async updateVolumes () {
      const validate = await this.validate()
      if (validate === false) {
        return false
      }
      this.request = true
      const data = this.checkUpdate()
      try {
        await this.$api.updateVolumes(this.id, data)
        this.request = false
        this.$store.dispatch('setSnackBar', { text: 'Atualizado com sucesso.' })
        this.fetchAll()
      } catch {
        this.request = false
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível atualizar, tente novamente mais tarde.', color: 'red' })
      }
      this.request = false
    }
  }
}
</script>
